var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-card-title',[_c('h3',[_vm._v("Item Description")])]),_vm._v(" "+_vm._s(_vm.note)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }